import { motion } from "framer-motion";
import { ShieldCheck, Link2, Umbrella, FileBadge } from "lucide-react";
import { useSiteContent, useSiteCopy } from "@/lib/siteContent";

const badges = [
  { icon: ShieldCheck, title: "LICENSED", sub: "State of Illinois" },
  { icon: Link2, title: "BONDED", sub: "Fully protected work" },
  { icon: Umbrella, title: "INSURED", sub: "You’re covered, always" },
];

export default function TrustBadges() {
  const { tx } = useSiteCopy();
  const { business } = useSiteContent();
  return (
    <section data-testid="trust-section" className="py-20 bg-navy border-y border-slate-800/60">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-6 items-stretch">
          {badges.map((b, i) => (
            <motion.div
              key={b.title}
              data-testid={`trust-badge-${b.title.toLowerCase()}`}
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="metal-card rounded-2xl p-8 text-center"
            >
              <b.icon className="w-10 h-10 text-electric mx-auto" strokeWidth={1.5} />
              <p className="mt-4 font-bebas text-3xl tracking-widest chrome-text">{tx(`trust-${b.title.toLowerCase()}`, b.title)}</p>
              <p className="mt-1 text-xs text-slate-500 uppercase tracking-widest">{tx(`trust-${b.title.toLowerCase()}-sub`, b.sub)}</p>
            </motion.div>
          ))}
          <motion.div
            data-testid="trust-license-card"
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="rounded-2xl p-8 text-center border border-electric/40 bg-gradient-to-b from-electric/10 to-transparent glow-blue"
          >
            <FileBadge className="w-10 h-10 text-electric mx-auto" strokeWidth={1.5} />
            <p className="mt-4 font-bebas text-3xl tracking-widest text-white">{tx("trust-license", "LICENSE")}</p>
            <p className="mt-1 text-sm text-electric font-semibold tracking-wider" data-testid="license-number">#{business.license}</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
